export enum RefundDetailNotificationType {
  /** Before applying for refund */
  REVIEW = 'review',

  /** After applying for refund */
  CONFIRMATION = 'confirmation',
}
